export default __webpack_public_path__ + "static/media/background.fe241cb8.png";